
import { useState } from 'react';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const openWhatsApp = () => {
    window.open('https://wa.me/5544988010206?text=Hello, I would like to talk about Social Security Law', '_blank');
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-black/95 backdrop-blur-sm border-b border-gray-800 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/38b84c1503cd17b8f12bcbc9adbcc594/b96be048663291dd024fde8a91ef186c.png"
              alt="Laginestra Lawyers"
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Menu */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('sobre')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('equipe')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Team
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              Contact Us
            </button>
            <Button size="sm" onClick={openWhatsApp}>
              WhatsApp
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </div>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <nav className="lg:hidden mt-4 pb-4 border-t border-gray-800 pt-4">
            <div className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('inicio')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Home
              </button>
              <button
                onClick={() => scrollToSection('sobre')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('servicos')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('equipe')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Team
              </button>
              <button
                onClick={() => scrollToSection('contato')}
                className="text-gray-300 hover:text-white transition-colors text-left cursor-pointer"
              >
                Contact Us
              </button>
              <Button size="sm" onClick={openWhatsApp} className="w-fit">
                WhatsApp
              </Button>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
}
